<template>
  <v-container class="metric-insights pa-0" fill-height fluid>
    <page-title title="Metric Insights"></page-title>
    <Tabs :settings="tabSettings"></Tabs>
    <router-view></router-view>
  </v-container>
</template>

<script>
import Tabs from '@/components/Tabs'
import routes from '@/route_names'

export default {
  name: 'MetricInsights',
  components: {
    Tabs
  },
  data: function() {
    return {}
  },
  computed: {
    tabSettings: function() {
      const tabs = []
      const enabledMetrics = this.$store.getters['campaign/enabledMetrics']
      if (enabledMetrics.indexOf('NPS') > -1) {
        tabs.push({
          id: routes.INSIGHTS_METRICS_NPS,
          label: 'NPS'
        })
      }
      if (enabledMetrics.indexOf('CSAT') > -1) {
        tabs.push({
          id: routes.INSIGHTS_METRICS_CSAT,
          label: 'CSAT'
        })
      }
      if (enabledMetrics.indexOf('CES') > -1) {
        tabs.push({
          id: routes.INSIGHTS_METRICS_CES,
          label: 'CES'
        })
      }
      return {
        preselected: null,
        tabs: tabs
      }
    }
  }
}
</script>

<style lang="stylus">
.metric-insights {
    margin-left -5px
    .lg-nav-tabs {
        margin-left 30px
    }
}
</style>
